<div *ngIf="showBJLTable" class = "card">
    <h3>{{'select_bjl' | titleText}}</h3>
    <div>
      <select (change)="onSPLChange($event)">
        <option value="">Select SMP</option>
        <option value="SPLITTER_1:4">SMP 1:4</option>
        <option value="SPLITTER_1:8">SMP 1:8</option>
      </select>
      <button (click)="addSPL()">Check</button>
    </div>
    <div *ngIf="showBJLTable" class="form-group col-md-2">
        <button (click)="callBJL()">Create New BJL</button>
    </div>
    <h2>{{ user_message }}</h2>
    <div *ngIf="showBJLTable">
            <app-table         
                table_title="Select BJL" 
                [inputData]="inputData" 
                (appItemEvent)="receiveTableEvent($event)">
            </app-table>
    </div>
</div>

<div *ngIf="select_smp_screen">
  
               <app-map-hd              
                [inputData]="inputData"
                (OnSelectProceedMap) = "OnSelectProceedMap($event)"
                (callBJLMap) = "callBJL()"
                [show_smp_table]="show_smp_table"
            ></app-map-hd>

    <div *ngIf="show_smp_table">
      <div class="form-group row">        
          <div class="form-group col-md-6">
            <label for="ada" class="lable-css">SMP Pit ID:</label>
            <input type="text" id="pit_id" formControlName="pitId" name="pit" placeholder="Enter PIT ID" required (change)="inputOnChange($event)" />
          </div>
          <div class="form-group col-md-6">
            <label for="ada" class="lable-css">BJL ID: </label>
            <input type="text" id="bjl_id" formControlName="bjlId" name="bjl" placeholder="Enter BJL ID" value="{{this.inputData.selected_bjl.bjl_id}}" readonly />
          </div>        
        <button (click)="checkDistance()" style="width: 20%;">Validate</button>
        <br />
        <div *ngIf="show_status">
           <b>Pit Fitness check :</b> {{ pit_validation.pit_status }} <br />
           <b>Pit distance :</b> {{ pit_validation.pit_distance }} <br />
           <b>Pit location status:</b> {{ pit_validation.pit_location }} <br />
        </div>
        
      </div>       
    </div>
    <div *ngIf="update_pit">
          <div class="form-group row">        
            <div class="form-group col-md-6">
              <label for="ada" class="lable-css">Enter Pit Size:</label>
              <input type="text" id="pit_size" formControlName="pit_size" name="pit_size" placeholder="Enter PIT Size" required (change)="pitSizeOnChange($event)" />
            </div>
            <button (click)="pitSizeChange()">Update Pit Size</button>
          </div>        
    </div>
    <div *ngIf="show_distance">
        <app-table                 
                table_title="selectBjl" 
                [inputData]="inputData"
                (appItemEvent)="receiveTableEventStructure($event)" >
        </app-table>
    </div>
</div>
<div *ngIf="upstream_screen">
  <h3>{{'upstream' | titleText }}</h3>
    <div>
        <input type="text" placeholder="Enter FJL ID for new SPL installation" id="fjl_Id" name="fjlId" required (change)="inputOnChange($event)"/>
        <select (change)="onfjlSPLChange($event)">
        <option value="">Select FJL Splitter type :</option><option value="1:4">SPLITTER_1:4</option><option value="1:8">SPLITTER_1:8</option></select>
        <button (click)="fjladdSPL()">Add New FJL-SPL</button>
    </div> 
  <app-table                 
    table_title="selectBjl" 
    [inputData]="inputData"
    (appItemEvent)="receiveTableEventUpstream($event)" >
  </app-table>
</div>


<div *ngIf="smp_connectivity_flag">
  <app-smp-connectivity-hd
    [inputData] = "tableData"
  ></app-smp-connectivity-hd>
</div>

<div *ngIf="trench_creation">  
    <div class="form-group row">        
        <div class="form-group col-md-6">
          <label for="a_pit" class="lable-css">Enter A Pit:</label>
          <input type="text" id="a_pit" formControlName="a_pit" name="a_pit" placeholder="Enter A PIT" required (change)="updateVal($event,'a_pit')" />
        </div>
        <div class="form-group col-md-6">
          <label for="z_pit" class="lable-css">Enter Z Pit:</label>
          <input type="text" id="z_pit" formControlName="z_pit" name="z_pit" placeholder="Enter z PIT" required (change)="updateVal($event,'z_pit')" />
        </div>
    </div>
    <div class="form-group row">   
        <div class="form-group col-md-6">
          <label for="no_of_pits" class="lable-css">Enter No. of Pits:</label>
          <input type="text" id="no_of_pits" formControlName="no_of_pits" name="no_of_pits" placeholder="Enter No. of Pits" required (change)="updateVal($event,'no_of_pits')" />
        </div>
        <div class="form-group col-md-6">
          <button type="submit" (click)="onSubmit()"> Submit </button>
        </div>
    </div> 
</div>

<div *ngIf="final_screen" class = "card">
    <h3>{{'final_screen' | titleText }}</h3>
    <div style="margin-top: 20px; display: flex; align-items: center">
        <button (click)="receiveTableEventFinalCall()">Click To Proceed</button>
    </div>
    
    <app-table       
        [inputData]="inputData"
    >
    </app-table>
</div>

<div *ngIf="showADRCard">
    <h3 *ngIf="showADRCard">{{'adr' | titleText}}</h3>
    <!-- <app-upload-file [flowName]="flowName" (uploaded)="fileUploaded($event)" [showADRCard]="showADRCard"
            [inputData]="inputData" [selectedRow]="selectedRow" >
    </app-upload-file>
    <form [formGroup]="myAdrForm" (ngSubmit)="table_function_called()">

        <div class="row">
            <div class="col-md-3 form-group">
                <button type="submit" class="primary">
                        Submit
                </button>
            </div>
        </div>
    </form> -->
    <button class="primary" (click)="table_function_called()">
        Submit
    </button>
    <app-table       
        [inputData]="inputData"
    >
    </app-table>
</div>


<div *ngIf="showMessage" class="card">
        <app-message 
            [showMessage]="showMessage"
            [MessageToShow]="MessageToShow"
            url={{url}}
            msg={{msg}}
            filename={{filename}}
        >
        </app-message>
</div>
<!-- spinner Component Called-->
<div *ngIf="isLoading">
  <ngx-spinner type = "ball-scale-multiple"></ngx-spinner> 
</div>